'use client';

import Avatar from "./components/Avatar";
import BrandColor from "./components/BrandColor";
import BrandMono from "./components/BrandMono";
import Color from "./components/Color";
import Combine from "./components/Combine";
import Mono from "./components/Mono";
import Text from "./components/Text";
import { COLOR_GRADIENT, COLOR_PRIMARY, TITLE } from "./style";
var Icons = Mono;
Icons.Color = Color;
Icons.Text = Text;
Icons.Combine = Combine;
Icons.Avatar = Avatar;
Icons.Brand = BrandMono;
Icons.BrandColor = BrandColor;
Icons.colorPrimary = COLOR_PRIMARY;
Icons.colorGradient = COLOR_GRADIENT;
Icons.title = TITLE;
export default Icons;